import {NOTIFICATION_EVENTS, NotificationPreferences} from '.'
import { ControllerRegistrationListItem } from '../components/ui'

class User {
    constructor(firstName = '', lastName = '', email = '', username = '', permissions = [], teams = [], groups = [], notificationPreferences = [], id = null, activeTeam = null) {
        this.id = id
        this.firstName = firstName
        this.lastName = lastName
        this.email = email
        this.username = username
        this.permissions = permissions
        this.teams = teams
        this.groups = groups

        if (activeTeam) {
            this.activeTeam = parseInt(activeTeam)
        } else if (teams && teams.length > 0) {
            this.activeTeam = teams[0]
        } else {
            this.activeTeam = null
        }

        if (notificationPreferences && notificationPreferences.length > 0) {
            this.notificationPreferences = notificationPreferences.map((p) => NotificationPreferences.fromAPIObject(p)).filter((p)=>p !== null)
        } else {
            this.notificationPreferences = [(new NotificationPreferences())]
        }

        this.safeGetNotifyOnEvents = this.safeGetNotifyOnEvents.bind(this)
        this.safeSetNotifyOnEvents = this.safeSetNotifyOnEvents.bind(this)
        this.safeGetHasPermission = this.safeGetHasPermission.bind(this)
        this.safeSetHasPermission = this.safeSetHasPermission.bind(this)
        this.toAPIObject = this.toAPIObject.bind(this)
    }

    /* Handy herlpers for UI Presentation */
    get _group() {
        if (this.groups) {
            if (this.isSupport) {
                return "Support"
            } else if (this.isDealer) {
                return "Dealer"
            } else if (this.isCustomer) {
                return "Customer"
            }
        }
        return "None"
    }

    get _name() {
        if (this.firstName && this.lastName && this.firstName.length > 0 && this.lastName.length > 0) {
            return `${this.firstName} ${this.lastName}`
        } else if (this.firstName && this.firstName.length > 0) {
            return this.firstName
        } else if (this.lastName && this.lastName.length > 0) {
            return this.lastName
        } else {
            return ''
        }
    }
    /* end handy helpers*/

    get name() {
        if (this.firstName && this.lastName && this.firstName.length > 0 && this.lastName.length > 0) {
            return `${this.firstName} ${this.lastName}`
        } else if (this.firstName && this.firstName.length > 0) {
            return this.firstName
        } else if (this.lastName && this.lastName.length > 0) {
            return this.lastName
        } else if (this.username && this.username.length > 0) {
            return this.username
        } else if (this.email && this.email.length > 0) {
            return this.email
        } else {
            return undefined
        }
    }

    get activeNotificationPreferences() {
        try {
            return this.notificationPreferences.filter(p => p.team === this.activeTeam)[0]
        } catch (error) {
            console.log(error)
        }
        return new NotificationPreferences()
    }

    get EMAILnotifications() {
        try {
            if(this.activeNotificationPreferences.notifyMethods.includes(1)){
                return true
            }
            return false
        } catch (error) {
            console.log(error)
        }
    }

    set EMAILnotifications(val) {
        try {
            let activePrefs = this.activeNotificationPreferences
            if(val){
                if (!activePrefs.notifyMethods.includes(1)) {
                    activePrefs.notifyMethods = activePrefs.notifyMethods.concat(1)
                }
            }
            else {
                activePrefs.notifyMethods = activePrefs.notifyMethods.filter(m => m !== 1)
            }
            this.notificationPreferences = this.notificationPreferences.filter(p => p.team !== activePrefs.team).concat(activePrefs)
        } catch (error) {
            console.log(error)
        }
    }

    get PHONEnotifications() {
        try {
            if(this.activeNotificationPreferences.notifyMethods.includes(2)){
                return true
            }
            return false
        } catch (error) {
            console.log(error)
        }
    }

    set PHONEnotifications(val) {
        try {
            let activePrefs = this.activeNotificationPreferences
            if(val){
                if (!activePrefs.notifyMethods.includes(2)) {
                    activePrefs.notifyMethods = activePrefs.notifyMethods.concat(2)
                }
            }
            else {
                activePrefs.notifyMethods = activePrefs.notifyMethods.filter(m => m !== 2)
            }
            this.notificationPreferences = this.notificationPreferences.filter(p => p.team !== activePrefs.team).concat(activePrefs)
        } catch (error) {
            console.log(error)
        }
    }

    get JDOnotifications() {
        try {
            if(this.activeNotificationPreferences.notifyMethods.includes(3)){
                return true
            }
            return false
        } catch (error) {
            console.log(error)
        }
    }

    set JDOnotifications(val) {
        try {
            let activePrefs = this.activeNotificationPreferences
            if(val){
                if (!activePrefs.notifyMethods.includes(3)) {
                    activePrefs.notifyMethods = activePrefs.notifyMethods.concat(3)
                }
            }
            else {
                activePrefs.notifyMethods = activePrefs.notifyMethods.filter(m => m !== 3)
            }
            this.notificationPreferences = this.notificationPreferences.filter(p => p.team !== activePrefs.team).concat(activePrefs)
        } catch (error) {
            console.log(error)
        }
    }

    get phone() {
        try {
            return this.activeNotificationPreferences.notifyPhone
        } catch (error) {
            console.log(error)
        }
    }

    set phone(val) {
        try {
            let activePrefs = this.activeNotificationPreferences
            activePrefs.notifyPhone = val
            this.notificationPreferences = this.notificationPreferences.filter(p => p.team !== activePrefs.team).concat(activePrefs)
        } catch (error) {
            console.log(error)
        }
    }    

    get notifyOnPowerOnOff() {
        return this.safeGetNotifyOnEvents([NOTIFICATION_EVENTS.CONTROLLER_POWER_UP, NOTIFICATION_EVENTS.CONTROLLER_POWER_DOWN])
    }

    set notifyOnPowerOnOff(val) {
        this.safeSetNotifyOnEvents(val, [NOTIFICATION_EVENTS.CONTROLLER_POWER_UP, NOTIFICATION_EVENTS.CONTROLLER_POWER_DOWN])
    }

    get notifyOnStartStop() {
        return this.safeGetNotifyOnEvents([NOTIFICATION_EVENTS.CONTROLLER_START, NOTIFICATION_EVENTS.CONTROLLER_STOP, NOTIFICATION_EVENTS.CONTROLLER_SCHEDULED_START, NOTIFICATION_EVENTS.CONTROLLER_SCHEDULED_STOP])
    }

    set notifyOnStartStop(val) {
        this.safeSetNotifyOnEvents(val, [NOTIFICATION_EVENTS.CONTROLLER_START, NOTIFICATION_EVENTS.CONTROLLER_STOP, NOTIFICATION_EVENTS.CONTROLLER_SCHEDULED_STOP, NOTIFICATION_EVENTS.CONTROLLER_SCHEDULED_START])
    }

    get notifyOnAlarmStop() {
        return this.safeGetNotifyOnEvents([NOTIFICATION_EVENTS.CONTROLLER_STOP_ON_ALARM])
    }

    set notifyOnAlarmStop(val) {
        this.safeSetNotifyOnEvents(val, [NOTIFICATION_EVENTS.CONTROLLER_STOP_ON_ALARM])
    }

    get notifyOnConnectionLoss() {
        return this.safeGetNotifyOnEvents([NOTIFICATION_EVENTS.CONTROLLER_MISSED_HEARTBEAT])
    }

    set notifyOnConnectionLoss(val) {
        this.safeSetNotifyOnEvents(val, [NOTIFICATION_EVENTS.CONTROLLER_MISSED_HEARTBEAT])
    }

    get notifyOnLowTank() {
        return this.safeGetNotifyOnEvents([NOTIFICATION_EVENTS.CONTROLLER_LOW_TANK_ALARM])
    }

    set notifyOnLowTank(val) {
        this.safeSetNotifyOnEvents(val, [NOTIFICATION_EVENTS.CONTROLLER_LOW_TANK_ALARM])
    }

    get notifyOnCommand() {
        return this.safeGetNotifyOnEvents([NOTIFICATION_EVENTS.COMMAND_SENT])
    }

    set notifyOnCommand(val) {
        this.safeSetNotifyOnEvents(val, [NOTIFICATION_EVENTS.COMMAND_SENT])
    }

    get notifyOnFlowIssue() {
        return this.safeGetNotifyOnEvents([NOTIFICATION_EVENTS.CONTROLLER_FLOW_DID_NOT_STOP])
    }

    set notifyOnFlowIssue(val) {
        this.safeSetNotifyOnEvents(val, [NOTIFICATION_EVENTS.CONTROLLER_FLOW_DID_NOT_STOP])
    }

    get activePermissions() {
        try {
            return this.permissions.filter(p => p.team === this.activeTeam)[0]
        } catch (error) {
            console.log(error)
        }
        return null
    }

    permissionsForTeam(t) {
        try {
            return this.permissions.filter(p => p.team === t)[0]
        } catch (error) {
            console.log(error)
        }
        return null
    }

    get canViewControllers() {
        return this.safeGetHasPermission(PERMISSIONS.STATUS_VIEW_ONLY)
    }

    set canViewControllers(val) {
        this.safeSetHasPermission(PERMISSIONS.STATUS_VIEW_ONLY, val)
    }

    canViewControllersForTeam(t) {
        return this.safeGetHasPermissionForTeam(PERMISSIONS.STATUS_VIEW_ONLY, t)
    }

    get canViewData() {
        return this.safeGetHasPermission(PERMISSIONS.VIEW_DATA)
    }

    set canViewData(val) {
        this.safeSetHasPermission(PERMISSIONS.VIEW_DATA, val)
    }

    canViewDataForTeam(t) {
        return this.safeGetHasPermissionForTeam(PERMISSIONS.VIEW_DATA, t)
    }

    get canSendCommands() {
        return this.safeGetHasPermission(PERMISSIONS.CONTROL_DEVICES)
    }

    set canSendCommands(val) {
        this.safeSetHasPermission(PERMISSIONS.CONTROL_DEVICES, val)
    }

    canSendCommandsForTeam(t) {
        return this.safeGetHasPermissionForTeam(PERMISSIONS.CONTROL_DEVICES, t)
    }

    get canManageTeam() {
        return this.safeGetHasPermission(PERMISSIONS.MANAGE_TEAM)
    }

    set canManageTeam(val) {
        this.safeSetHasPermission(PERMISSIONS.MANAGE_TEAM, val)
    }

    canManageTeamForTeam(t) {
        return this.safeGetHasPermissionForTeam(PERMISSIONS.MANAGE_TEAM, t)
    }

    get isSupport() {
        return this.groups && this.groups.length && this.groups.includes("Support")
    }

    get isDealer() {
        return this.groups && this.groups.length && this.groups.includes("Dealers")
    }

    get isCustomer() {
        return this.groups && this.groups.length && this.groups.includes("Customers")
    }

    static fromAPIObject(obj, activeTeam=null) {
        let permissions = []
        if (obj.team_permissions) {
            permissions = obj.team_permissions
        }
        return new User(obj.first_name, obj.last_name, obj.email, obj.username, permissions, obj.teams, obj.groups, obj.notification_preferences, obj.id, activeTeam)
    }

    static fromLocalStorageString(str, activeTeam=null) {
        let jsonObj = JSON.parse(str)
        let user = new User(jsonObj.firstName, jsonObj.lastName, jsonObj.email, jsonObj.username, jsonObj.permissions, jsonObj.teams, jsonObj.groups, [], jsonObj.id, activeTeam)
        user.notificationPreferences = jsonObj.notificationPreferences
        return user
    }

    toAPIObject() {
       let apiObj = {
           first_name: this.firstName,
           last_name: this.lastName,
           email: this.email,
           username: this.username,
           team_permissions: this.permissions,
           teams: this.teams,
           groups: this.groups,
           id: this.id
       }

       if (this.notificationPreferences && this.notificationPreferences.length > 0) {
           apiObj['notification_preferences'] = this.notificationPreferences.map(p => p.toAPIObject())
       }

       return apiObj
    }

    safeSetNotifyOnEvents(shouldNotify, events) {
        try {
            let activePrefs = this.activeNotificationPreferences
            let notifyEvents = activePrefs.notifyEvents
            events.map((event) => {
                if (shouldNotify) {
                    if (!notifyEvents.includes(event)) {
                        notifyEvents.push(event)
                    }
                } else {
                    if (notifyEvents.includes(event)) {
                        notifyEvents = notifyEvents.filter((e) => e !== event)
                    }
                }
                return event
            })
            activePrefs.notifyEvents = notifyEvents
            this.notificationPreferences = this.notificationPreferences.filter(p => p.team !== activePrefs.team).concat(activePrefs)
        } catch (error) {console.log(error)}
    }

    safeGetNotifyOnEvents(events) {
        try {
            let notifyEvents = this.activeNotificationPreferences.notifyEvents
            let eventsInNotifyEvents = events.map((event) => notifyEvents.includes(event))
            return !eventsInNotifyEvents.includes(false)
        } catch (error) {}
        return false
    }

    safeGetHasPermission(permission) {
        try {
            return ((this.activePermissions.permissions & permission) === permission)
        } catch (error) {
            return false
        }
    }

    safeGetHasPermissionForTeam(permission, team) {
        try {
            if (this.isSupport) {
                return true
            } else if (this.isDealer && (permission === PERMISSIONS.STATUS_VIEW_ONLY || permission === PERMISSIONS.VIEW_DATA)) {
                return true
            } else {
                return (this.isSupport || ((this.permissionsForTeam(team).permissions & permission) === permission))
            }
        } catch (error) {
            return false
        }
    }

    safeSetHasPermission(permission, hasPermission) {
        try {
            let activePerms = this.activePermissions
            if (hasPermission) {
                activePerms.permissions = activePerms.permissions | permission
                this.permissions = this.permissions.filter(p => p.team !== this.activeTeam).concat(activePerms)
            } else {
                activePerms.permissions = activePerms.permissions & ~permission
                this.permissions = this.permissions.filter(p => p.team !== this.activeTeam).concat(activePerms)
            }
        } catch (error) {console.log("err setting permission"); console.log(error)}
    }
}

const PERMISSIONS = {
    STATUS_VIEW_ONLY: 1,
    VIEW_DATA: 2,
    CONTROL_DEVICES: 4,
    MANAGE_TEAM: 8,
    ADMIN: 15,
}

export default User


// WEBPACK FOOTER //
// ./src/models/User.js